import { useMutation } from '@tanstack/react-query';
import { apiClient } from './client';

/** Logos and email images are uploaded to Engage, which returns the public address (JT1-1922). */
export const MAX_IMAGE_UPLOAD_BYTES = 2 * 1024 * 1024;

export function useUploadImage() {
  return useMutation({
    mutationFn: async (file: File) => {
      const form = new FormData();
      form.append('file', file);
      const { data } = await apiClient.post<{ data: { url: string } }>('/images', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return data.data.url;
    },
  });
}
